<!-- 精准匹配--基本信息 -->
<template>
    <Navbar :title="'精准匹配'" :rightBtn="rightBtn"></Navbar>
    <div class="index-container" @click="hideSearch">
        <div class="warpper-b" v-if="current == '1'">
            <div class="boxs">
                <p class='title'>基本信息</p>
                <van-cell-group outset>
                    <!-- <div class="match-container-search">
                        <van-field label="1.企业名称" v-model="formSearch.name" placeholder="请输入企业名称" @input="formDebounce"
                            @click-input.stop="handleInput" input-align="right" disabled>
                        </van-field>
                        <div class="detail" v-show="isFocus">
                            <search-detail :searchList="searchList" :isSearch="isSearch" @toMatchDetail="toMatchDetail"
                                :currentStr="currentSearchStr" @updateSearchStr="updateSearchStr" ref="searchDetails">
                            </search-detail>
                        </div>
                    </div> -->
                    <van-field v-model="formSearch.register_date" is-link readonly name="datetimePicker"
                        input-align='right' label="1.成立日期" placeholder="选择日期" @click="showDatePicker = true" />
                    <van-field v-model="formSearch.register_address" is-link readonly name="datetimePicker"
                        input-align='right' label="2.注册地址" placeholder="注册地区" @click="showAreaPicker = true" />

                    <!-- <Date v-model="formSearch.registerDate" name='2.成立日期' label='2.成立日期' placeholder='选择日期'></Date>
                    <Area v-model="formSearch.registerAddress" name='3.注册地址' label='3.注册地址' placeholder='注册地区'></Area> -->
                </van-cell-group>
            </div>
            <div class="boxs">
                <p class='title'>领域信息（多选）</p>
                <div class="field-ul">
                    <div class="flex-tag-select-container">
                        <div v-for="(item, i) in fieldList" :key="i" class="flex-tag-select-item"
                            :class="{ 'selected': item.checked }" @click="() => toggleItem(item)">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="boxs" style="margin: 20px 0;">
                <van-cell-group outset>
                    <van-field v-model="formSearch.other_realm" name="其他领域" label="其他领域" placeholder="上面没有所属领域，请手动填写" />
                </van-cell-group>
            </div>
        </div>
        <div class="warpper-b" v-else-if="current == '2'">
            <div class="boxs">
                <p class='title'>1、企业规模（企业营收，单位：元/年）</p>
                <van-cell-group outset>
                    <van-cell>

                        <template #right-icon>
                            <van-radio-group v-model="formSearch.company_scale">
                                <van-radio name="1">200万内</van-radio>
                                <van-radio name="2">200万 - 2000万</van-radio>
                                <van-radio name="3">2000万 - 1亿</van-radio>
                                <van-radio name="4">1亿及以上</van-radio>
                            </van-radio-group>
                        </template>

                    </van-cell>

                </van-cell-group>
            </div>
        </div>
        <div class="warpper-b" v-else-if="current == '3'">
            <div class="boxs">
                <p class='title'>是否是有效期内的科技型中小企业、高新技术企业、技术中心、工程中心、实验室等称号</p>
                <van-cell-group outset>
                    <van-cell>
                        <template #right-icon>
                            <van-radio-group v-model="formSearch.validity" direction="horizontal"
                                @change="changeValidity">
                                <van-radio name="1">是</van-radio>
                                <van-radio name="0">否</van-radio>
                            </van-radio-group>
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>
            <div v-if="formSearch.validity == '1'">
                <div class="boxs" v-for="(item, index) in validityList" :key="index">
                    <p class='title'>{{ item.name }}</p>
                    <van-cell-group outset>
                        <van-cell>
                            <template #right-icon>
                                <van-radio-group v-model="formSearch[item.sn]" direction="horizontal"
                                    v-if="item.type == 'radio'">
                                    <van-radio name="1">是</van-radio>
                                    <van-radio name="0">否</van-radio>
                                </van-radio-group>
                                <van-checkbox-group v-model="formSearch[item.sn]" v-if="item.type == 'checkbox'"
                                    direction="horizontal" @click="clickCheckboxNo(item.sn)">
                                    <van-checkbox shape="square" name="0">否</van-checkbox>
                                </van-checkbox-group>
                                <van-checkbox-group v-model="formSearch[item.sn]" v-if="item.type == 'checkbox'"
                                    direction="horizontal" @click="clickCheckbox(item.sn)">
                                    <van-checkbox shape="square" name="1">市级</van-checkbox>
                                    <van-checkbox shape="square" name="2">省级</van-checkbox>
                                    <van-checkbox shape="square" name="3">国家级</van-checkbox>
                                </van-checkbox-group>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </div>
            </div>
        </div>
        <div class="warpper-b" v-else-if="current == '4'">
            <h1 class="h1-title">热点类别填报</h1>
            <div class="boxs" v-for="(item, index) in hotCategory" :key="index">
                <p class="main-title">{{ item.title }}</p>
                <p class='title'>{{ item.name }}</p>
                <van-cell-group outset>
                    <van-cell>
                        <template #right-icon>
                            <van-radio-group v-model="formSearch[item.sn]" direction="horizontal"
                                v-if="item.type == 'radio' && item.sn != 'dr_number_flag'">
                                <van-radio name="1">{{ item.label_1|| '有'}}</van-radio>
                                <van-radio name="0">{{ item.label_2|| '无'}}</van-radio>
                            </van-radio-group>
                            <van-radio-group v-model="formSearch[item.sn]" direction="horizontal"
                                v-if="item.sn == 'dr_number_flag'">
                                <van-radio name="2">{{ item.label_1}}</van-radio>
                                <van-radio name="1">{{ item.label_3}}</van-radio>
                                <van-radio name="0">{{ item.label_2}}</van-radio>
                            </van-radio-group>
                            <!-- <van-checkbox-group v-model="formSearch[item.sn]" v-if="item.type == 'checkbox'"
                                direction="horizontal" @click="clickCheckbox(item.sn)">
                                <van-checkbox shape="square" name="1">3个及以上博士</van-checkbox>
                                <van-checkbox shape="square" name="2">1个及以上博士</van-checkbox>
                                <van-checkbox shape="square" name="3">知名企业中高管1个及以上</van-checkbox>
                            </van-checkbox-group> -->
                            <van-checkbox-group v-model="formSearch[item.sn]" v-if="item.type == 'checkbox'"
                                direction="horizontal" @click="clickCheckboxNo(item.sn)">
                                <van-checkbox shape="square" name="0">无</van-checkbox>
                            </van-checkbox-group>
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>
        </div>

        <div class="float-action flex" v-if="current == 4">
            <div class="flex-item">
                <van-button class="btn" type="primary" @click="goSearchResult">查看结果</van-button>
            </div>
        </div>
        <div class="float-action flex" v-else>
            <div class="flex-item btn-collect-box">
                <van-button class="btn" type="danger" @click="goSearchResult">查看当前匹配结果</van-button>
            </div>
            <div class="flex-item">
                <van-button class="btn" type="primary" @click="next">补充资料更精准匹配</van-button>

            </div>
        </div>
    </div>

    <van-popup v-model:show="showDatePicker" position="bottom">
        <van-datetime-picker type="date" :formatter="formatter" @confirm="onConfirmDate" :min-date="minDate" @cancel="showDatePicker = false" />
    </van-popup>
    <van-popup v-model:show="showAreaPicker" position="bottom">
        <van-area :value="areaDefaultValue" titlvante="选择地区" :area-list="areaList" @confirm="onConfirmArea"
            @cancel="showAreaPicker = false" />
    </van-popup>
</template>

<script>
import { areaList } from '@vant/area-data';
import { Dialog, Notify } from "vant"
import moment from "moment"
import Select from '@/components/Select.vue'
import SearchDetail from '@/components/SearchDetail.vue'
import Dates from '@/components/Date.vue'
import Area from '@/components/Area.vue'

import Navbar from '@/components/Navbar'
import { clickUrl } from '@/utils'
import { getSearchHistory, setSearchHistory } from '@/utils/storage'

import { getQueryAll, queryBySpec, getCompanyLists,getCompanyInfoV2,getCompanySearchInfoV2,companyInfoV3 } from "@/api/home"
export default {

    data() {

        return {
            areaList,
            querySearch: '',
            querySearchType: 0,
            isFocus: false,
            searchList: [],
            isSearch: false,
            current: 1,
            showDatePicker: false,
            showAreaPicker: false,
            formSearch: {},
            formSearchDefault: {
                name: '',
                register_date: null,
                register_address: '四川省/成都',
                other_realm: '',
                validity: '1',
                // checked: ['0'],

                company_scale: '1',

                smes_flag: '0',
                htzte_flag: '0',
                technology_center_flag: ['0'],
                engineering_center_flag: ['0'],
                engineering_laboratory_flag: ['0'],
                key_laboratory_flag: ['0'],
                industrial_design_center_flag: ['0'],

                research_input_flag: '0',
                invention_patent_flag: '0',
                international_cooperation_flag: '0',
                investment_fixed_assets_flag: '0',
                dr_number_flag: '0',
                high_level_talents_flag: '0',
                // high_level_talents_flag1: '0',
                shareholders_flag: '0',
                nonlocal_dr_flag: '0',
                // loan_flag: '0',
                last_year_loan_flag: '0',
                last_year_finance_flag: '0',
                future_loan_flag: '0',
                future_finance_flag: '0',
            },
            fieldList: [
                // { name: '电子信息',value: '',checked: false },
                // { name: '物联网',value: '',checked: false },
                // { name: '集成电路',value: '',checked: false },
                // { name: '电子商务',value: '',checked: false },
                // { name: '云计算',value: '',checked: false },
                // { name: '互联网',value: '',checked: false },
                // { name: '人工智能',value: '',checked: false },
                // { name: '大数据',value: '',checked: false },
                // { name: '区块链',value: '',checked: false },
                // { name: '节能环保',value: '',checked: false },
                // { name: '生物医药',value: '',checked: false },
                // { name: '生态修复',value: '',checked: false },
                // { name: '大数据',value: '',checked: false },
                // { name: '新能源与节能新能源汽车',value: '',checked: false },
                // { name: '医疗器械机器人高端装备',value: '',checked: false },
                // { name: '医疗美容',value: '',checked: false },
                // { name: '智能制造',value: '',checked: false },
                // { name: '新材料',value: '',checked: false },
                // { name: '航空航天',value: '',checked: false },
                // { name: '载体',value: '',checked: false },
                // { name: '科普类',value: '',checked: false },
            ],
            validityList: [
                { name: '1、是否是有效期内的科技型中小企业称号', value: '0', sn: 'smes_flag', type: 'radio' },
                { name: '2、是否是有效期内的高新技术企业称号', value: '0', sn: 'htzte_flag', type: 'radio' },
                { name: '3、是否是有效期内的技术中心称号', value: '0', sn: 'technology_center_flag', type: 'checkbox' },
                { name: '4、是否是有效期内的工程中心称号', value: '0', sn: 'engineering_center_flag', type: 'checkbox' },
                { name: '5、是否是有效期内的工程实验室称号', value: '0', sn: 'engineering_laboratory_flag', type: 'checkbox' },
                { name: '6、是否是有效期内的重点实验室称号', value: '0', sn: 'key_laboratory_flag', type: 'checkbox' },
                { name: '7、是否是有效期内的工业设计中心称号', value: '0', sn: 'industrial_design_center_flag', type: 'checkbox' },
            ],
            checkboxList: [
                { name: "否", value: "0", checked: false },
                { name: "市级", value: "1", checked: false },
                { name: "省级", value: "2", checked: false },
                { name: "国家级", value: "3", checked: false },
            ],
            hotCategory: [
                { title: "1、科技类", name: '上年度有无研发投入', value: '0', sn: 'research_input_flag', type: 'radio' },
                { name: '有无授权发明专利', value: '0', sn: 'invention_patent_flag', type: 'radio' },
                { name: '有无国际科技合作', value: '0', sn: 'international_cooperation_flag', type: 'radio' },
                { title: "2、工业类", name: '上年度有无固定资产投入', value: '0', sn: 'investment_fixed_assets_flag', type: 'radio' },
                // { title: "3、人才类", name: '高层次人才情况', value: '0', sn: 'high_level_talents_flag', type: 'checkbox' },
                { title: "3、人才类", name: '博士人数情况', value: '0', sn: 'dr_number_flag', type: 'radio',label_1:'2个及以上博士',label_3:'1个博士',label_2:'无' },
                { name: '知名企业中有无高管', value: '0', sn: 'high_level_talents_flag', type: 'radio' },
                { name: '企业股东或成员是否有国内外高校或科研院在编、全职人员', value: '0', sn: 'shareholders_flag', type: 'radio' },
                { name: '企业有无从外地引进博士学历人才', value: '0', sn: 'nonlocal_dr_flag', type: 'radio' },
                { title: "4、贷款类", name: '上年度是否有贷款', value: '0', sn: 'last_year_loan_flag', type: 'radio' },
                { name: '上年度是否有融资', value: '0', sn: 'last_year_finance_flag', type: 'radio' },
                { name: '未来有贷款计划', value: '0', sn: 'future_loan_flag', type: 'radio' },
                { name: '未来有融资计划', value: '0', sn: 'future_finance_flag', type: 'radio' },
            ],
            areaDefaultValue: '510100',
            currentSearchStr: '',
            stoageHistory: [],
            searchFromListFlag: false,//企业名称是否是从下拉列表中选择的 true 是，false 否
            minDate: new Date('1949/01/01'),
            register_address1:0,
            register_address2:0,
            register_address:'',
            startDate:''
        }
    },
    components: { Select, SearchDetail, Dates, Area, Navbar },
    computed: {
        rightBtn(){
            // return this.current != '1' ? true: false
            return true
        }
    },

    mounted() {
        this.stoageHistory = getSearchHistory() || []
        this.querySearchType = this.$route.query.type || 0
        let search = this.$route.query.search || ''
        this.formSearch = Object.assign({},this.formSearchDefault)

        this.current = Number(this.$route.params.id)
        if (search) {
            this.formSearch = Object.assign({},this.formSearch, {
                ...JSON.parse(search),
                // register_date: !this.$route.meta.isBack ? JSON.parse(search).reg_date : JSON.parse(search).register_date ? JSON.parse(search).register_date : '',
                name: JSON.parse(search).name
            })

        //     if (!this.formSearch.name) {
        //         this.getQueryAll()
        //         return false
        //     }
        //     if (this.$route.query.type == '2' && !this.$route.meta.isBack) {
        //         this.search('init')
        //     } else {
        //         this.searchFromListFlag = true
        //     }
        }
        this.getCompanyMatchInfo()
         if (!this.$route.meta.isBack) {
            this.getCompanySearchInfo()
        }
        
    },
    watch: {
        '$route'(to, from) { //监听路由是否变化
            if (this.$route.params.id) {//判断id是否有值
                this.current = Number(this.$route.params.id)
            }
        },
        // formSearch: {//深度监听，可监听到对象、数组的变化
        //     handler(oldVal,newVal) {
        //         this.formDebounce(this);
        //     },
        //     deep: true //true 深度监听
        // }
    },
    methods: {
        moment,
          async search(type) {
            this.searchFromListFlag = false
            this.isSearch = true
            this.currentSearchStr = this.formSearch.name
            let res = await getCompanyLists({ keywords: this.formSearch.name })
            this.searchList = res.result || []
            if(type && res.result.length == 1){
                this.formSearch.name = res.result[0].name
                this.formSearch.register_date = res.result[0].reg_date
                console.log(this.formSearch.register_date,'===>');
                this.searchFromListFlag = true
                this.isFocus = false
            }else{
                this.formSearch.register_date = ''
                 console.log(this.formSearch.register_date,'===>');
                this.isFocus = true
            }

            this.isSearch = false
        },
        async getCompanyMatchInfo() {
            try {
                let res = await companyInfoV3()
                this.formSearch.tags = res.result.tags
                console.log(JSON.parse(res.result.other_info));
                console.log(res.result);
                if(res.result.register_address){
                    this.formSearch.register_address=JSON.parse(res.result.other_info).area.merger_name.replace(/,/g,'/')
                }
                if(res.result.register_date){
                        this.formSearch.register_date = JSON.parse(res.result.other_info).startDate
                        console.log(this.formSearch.register_date);
                }
                 if (sessionStorage.getItem('time')&&sessionStorage.getItem('time')!=this.formSearch.register_date) {
                    this.formSearch.register_date = sessionStorage.getItem('time')
                   console.log(this.formSearch.register_date);
                }
                this.getQueryAll()
                let result = res.result.extend_data ? JSON.parse(res.result.extend_data) : {}
                if (Object.keys(result).length) {
                  this.getMatchInfoView(result)  
                }
            } catch {
                
            }
          
        },
        async getCompanySearchInfo() {
            try {
                let res = await getCompanySearchInfoV2({ name: this.formSearch.name })
                console.log(res);
                if (res.result.startDate) {
                    this.formSearch.register_date = res.result.startDate
                    console.log(',===');
                }
                if (sessionStorage.getItem('time')&&sessionStorage.getItem('time')!=this.formSearch.register_date) {
                    this.formSearch.register_date = sessionStorage.getItem('time')
                   console.log(this.formSearch.register_date);
                }

                if(res.result.area.merger_name){
                    this.formSearch.register_address = res.result.area.merger_name.replace(/,/g,'/')
                }
               
                let areaDefaultValue = res.result.area.area_code.toString().substr(0, 6)
                if (areaDefaultValue == '510118') {
                    areaDefaultValue = '510132'
                }
                this.areaDefaultValue = areaDefaultValue
                console.log('areaDefaultValue-350',areaDefaultValue)
                
            } catch {
                
            }
            
        },
      
        toMatchDetail(arg) {
            console.log(this, arg)
            this.searchFromListFlag = true
            this.formSearch.name = arg.name
            this.formSearch.register_date = arg.reg_date
            this.setHistory(arg.name)
            // this.getQueryBySpec()
        },
        formDebounce: debounce(function () {
            this.search()
        }, 1000),
        handleInput(val) {
            this.isFocus = true
        },
        hideSearch() {
            this.isFocus = false
            this.setHistory(this.formSearch.name)
        },
        setHistory(val) {
            let history = getSearchHistory()
            if (!val) {
                return false
            }
            if (!history.length) {
                this.stoageHistory.unshift(val)
                setSearchHistory(this.stoageHistory)
                return false
            }
            if (this.stoageHistory.indexOf(val) != -1) {
                this.stoageHistory.splice(this.stoageHistory.indexOf(val), 1)
                this.stoageHistory.unshift(val)
            } else {
                this.stoageHistory.unshift(val)
            }

            if (this.stoageHistory.length > 6) {
                this.stoageHistory.pop()
            }
            setSearchHistory(this.stoageHistory)
        },
        updateSearchStr(arg) {
            this.formSearch.name = arg
            this.search('history')
            this.isFocus = true
        },
        /**
         * 获取领域信息
         */
        async getQueryAll() {
            let res = await getQueryAll({ pageSize: 100 })
            this.fieldList = res.result.data.map((item, index) => {
                return {
                    ...item,
                    checked: this.formSearch.tags && this.formSearch.tags.includes(item.id) ? true : index == '0' ? true : false
                }
            })
            console.log(this.formSearch.tags)
        },
        async getQueryBySpec() {
            let params = {
                name: this.formSearch.name || ''
            }
            let res = await queryBySpec(params)
            this.formSearch = res.data
        },
        toggleItem(item) {
            item.checked = !item.checked
        },
        /**
         * 匹配的企业名称必须是从下拉列表中选择的
         */
        next() {
            // if (this.current == '1' && !this.formSearch.name) {
            //     this.$toast('请输入公司名称')
            //     return false
            // }
            // if (!this.searchFromListFlag) {
            //     this.$toast('请从公司名称列表中选择一项')
            //     return false
            // }
            let fieldList = this.fieldList
            let tags = fieldList.filter(item => item.checked) || []
            if (!tags.length) {
                this.$toast('请至少选择一项领域信息')
                return false
            }
            this.current += 1
            // this.$router.push({ path: '/search/' + this.current })
            clickUrl('/search/'+this.current,{ search: JSON.stringify(this.formSearch), type: 1 })
        },
        /**
         * 匹配的企业名称必须是从下拉列表中选择的
         */
        async goSearchResult() {
            // if (this.current == '1' && !this.formSearch.name) {
            //     this.$toast('请输入公司名称')
            //     return false
            // }
            // if (!this.searchFromListFlag) {
            //     this.$toast('请从公司名称列表中选择一项')
            //     return false
            // }
            let formSearch = this.formSearch
            let params = {}
            params.company_name = formSearch.name
            let extend_data = this.getExtendData(params)
            params.extend_data = JSON.stringify(extend_data)
            params['high_level_talents_flag1'] = formSearch['high_level_talents_flag']
            let fieldList = this.fieldList
            let tags = fieldList.filter(item => item.checked) || []
            if (!tags.length) {
                this.$toast('请至少选择一项领域信息')
                return false
            }
            // params.tags = tags.length ? tags.map(item => item.id).join(','):''
            // params.tagList = tags.map(item=>{
            //     return {
            //         name:item.name,
            //         id:item.id,
            //     }
            // })
            params.tags = tags.length ? tags.map(item => item.id) : []
            // if(formSearch.register_address){
            //     params.register_address = formSearch.register_address.replace(/\//g,'')
            // }

            console.log(params)
            // this.$store.commit('SET_QUERY_PARAMS', params)
            // clickUrl('/search_result', { search: JSON.stringify(params), type: 1 })
            sessionStorage.removeItem('matchList')
            sessionStorage.removeItem('declare_type2')
            sessionStorage.removeItem('declare_type1')
            clickUrl('/ai/enterprise_match', { search: JSON.stringify(params), type: 1 })
        },
        getExtendData(params) {
            let formSearch = this.formSearch
            if (formSearch.validity == '0') {
                formSearch.smes_flag = '0'
                formSearch.htzte_flag = '0'
                formSearch.technology_center_flag = ['0']
                formSearch.engineering_center_flag = ['0']
                formSearch.engineering_laboratory_flag = ['0']
                formSearch.key_laboratory_flag = ['0']
                formSearch.industrial_design_center_flag = ['0']
            }
            let obj = {}
             for (var i in formSearch) {
                params[i] = formSearch[i]
                // if (Array.isArray(formSearch[i]))
                //     // params[i] = formSearch[i].join('')
                //     params[i] = formSearch[i]
                let k = '',t = 19
                switch (i) {
                    case "company_scale":
                        k = 6
                        t = 2
                        break
                    case "register_date"://企业成立时间
                        k = 3
                        t = 1
                        break
                    case "validity"://有效期内的科技型中小企业、高新技术企业、技术中心、工程中心、实验室等称号
                        k = 10
                        t = 0
                        break
                    case "smes_flag"://有效期内的科技型中小企业称号
                        k = 11
                        break
                    case "htzte_flag"://有效期内的高新技术企业称号
                        k = 12
                        break
                    case "research_input_flag"://上年度有无研发投入
                        k = 30
                        break
                    case "invention_patent_flag"://有无授权发明专利
                        k = 31
                        break
                    case "international_cooperation_flag"://有无国际科技合作
                        k = 32
                        break
                    case "investment_fixed_assets_flag"://上年度有无固定资产投入
                        k = 34
                        break
                    case "shareholders_flag"://企业股东或成员是否有国内外高校或科研院在编、全职人员
                        k = 38
                        break
                    case "nonlocal_dr_flag"://企业有无从外地引进博士学历人才
                        k = 39
                        break
                    case "last_year_loan_flag"://上年度有贷款
                        k = 41
                        break
                    case "last_year_finance_flag"://上年度有融资
                        k = 43
                        break
                    case "future_loan_flag"://未来有贷款计划
                        k = 42
                        break
                    case "future_finance_flag"://未来有融资计划
                        k = 48
                        break
                    case "technology_center_flag"://3、是否是有效期内的技术中心称号
                        this.getCaseFromCheck(obj,formSearch[i],13,'1')
                        this.getCaseFromCheck(obj,formSearch[i],14,'2')
                        this.getCaseFromCheck(obj,formSearch[i],15,'3')
                        break
                    case "engineering_center_flag"://4、是否是有效期内的工程中心称号
                        this.getCaseFromCheck(obj,formSearch[i],16,'1')
                        this.getCaseFromCheck(obj,formSearch[i],17,'2')
                        this.getCaseFromCheck(obj,formSearch[i],18,'3')
                        
                        break
                    case "engineering_laboratory_flag"://5、是否是有效期内的工程实验室称号
                        this.getCaseFromCheck(obj,formSearch[i],19,'1')
                        this.getCaseFromCheck(obj,formSearch[i],20,'2')
                        this.getCaseFromCheck(obj,formSearch[i],21,'3')
                        break
                    case "key_laboratory_flag"://6、是否是有效期内的重点实验室称号
                        this.getCaseFromCheck(obj,formSearch[i],22,'1')
                        this.getCaseFromCheck(obj,formSearch[i],23,'2')
                        this.getCaseFromCheck(obj,formSearch[i],24,'3')
                        break
                    case "industrial_design_center_flag"://7、是否是有效期内的工业设计中心称号
                        this.getCaseFromCheck(obj,formSearch[i],25,'1')
                        this.getCaseFromCheck(obj,formSearch[i],26,'2')
                        this.getCaseFromCheck(obj,formSearch[i],27,'3')
                        break
                    case "dr_number_flag":
                        k = 36
                        t = 3
                        break
                    case "high_level_talents_flag":
                        k = 37
                        t = 3
                        break
                    default: 
                        break
                }
                
                 if (k == 3) { 
                   obj[k] = {
                       id: k,
                        e: formSearch[i],
                        t: t,
                    }  
                 }else if (k == 6) {
                    obj[k] = {
                        id: k,
                        t: t,
                    }
                    if (formSearch[i] == '1') {
                        obj[6].l = 2000000
                    } else if (formSearch[i] == '2') {
                        obj[6].g = 2000000
                        obj[6].l = 20000000
                    } else if (formSearch[i] == '3') {
                        obj[6].g = 20000000
                        obj[6].l = 100000000
                    } else if (formSearch[i] == '4') {
                        obj[6].g = 100000000
                    }
                } else if (k == 36) {
                    obj[k] = {
                        id: k,
                        e: formSearch[i],
                        t: t
                    }
                } else if (!Array.isArray(formSearch[i]) && k != '') {
                    obj[k] = {
                        id: k,
                        e: formSearch[i] == '1' ? 1 : 0,
                        t: t
                    }
                }
            }
            return obj
        },
        getCaseFromCheck(obj, str, k, v , t) {
            obj[k] = {
                id: k,
                e: str.includes(v) ? 1 : 0,
                t: t ? t : 19
            }
        },
        clickCheckboxNo(sn) {
            this.formSearch[sn] = ['0']
        },
        clickCheckbox(sn) {
            let arr = this.formSearch[sn]
            let arrNew = []
            for (var i in arr) {
                if (arr[i] != 0) {
                    arrNew.push(arr[i])
                }
            }
            this.formSearch[sn] = arrNew
        },
        onConfirmDate(value) {
            this.formSearch.register_date = moment(value).format('YYYY-MM-DD')
            sessionStorage.setItem('time',this.formSearch.register_date)
            this.showDatePicker = false
        },
        onConfirmArea(areaValues) {
            console.log('areaValues-664',areaValues)
            this.formSearch.register_address = areaValues
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
            this.showAreaPicker = false
        },
        changeValidity(val) {
            // if (val == '0') {
            //     this.formSearch = Object.assign({}, this.formSearch, {
            //         smes_flag: '0',
            //         htzte_flag: '0',
            //         technology_center_flag: ['0'],
            //         engineering_center_flag: ['0'],
            //         engineering_laboratory_flag: ['0'],
            //         key_laboratory_flag: ['0'],
            //         industrial_design_center_flag: ['0'],
            //     })
            // }
        },
        //获取该公司的匹配数据，填充在页面
        
        getMatchInfoView(result) {
            console.log(result);
            let form = {}
            for (var i in result) {
                let ed = result[i].t == '19' || result[i].t == '3' ? result[i].e.toString() : result[i].e
                switch (i) {
                    case 6:
                    case "6":
                        // if (result[i].e == '2000000') {
                        //     form.company_scale = '1'
                        // } else if (result[i].g == '2000000' && result[i].l == '20000000') {
                        //     form.company_scale = '2'
                        // } else if (result[i].g == '20000000' && result[i].l == '100000000') {
                        //     form.company_scale = '3'
                        // } else if (result[i].g == '100000000') {
                        //     form.company_scale = '4'
                        // }
                        if (result[i].l < '2000000') {
                            form.company_scale = '1'
                        } else if (result[i].l >= '2000000' && result[i].l < '20000000') {
                            form.company_scale = '2'
                        } else if (result[i].l >= '20000000' && result[i].l < '100000000') {
                            form.company_scale = '3'
                        } else if (result[i].l >= '100000000') {
                            form.company_scale = '4'
                        }
                        break
                    case "3"://企业成立时间
                    case 3:
                        console.log(sessionStorage.getItem('time')==this.formSearch.register_date);
                        if(sessionStorage.getItem('time')&&sessionStorage.getItem('time')!=this.formSearch.register_date){
                                console.log(444444444);
                            form.register_date = moment(result[i].e).format('YYYY-MM-DD')
                        }else{
                             form.register_date =this.formSearch.register_date
                        }
                      
                        break
                    case "10"://有效期内的科技型中小企业、高新技术企业、技术中心、工程中心、实验室等称号
                    case 10:
                        form.validity = result[i].e.toString()
                        break
                    case 11://有效期内的科技型中小企业称号
                    case "11":
                        form.smes_flag = ed
                        break
                    case "12"://有效期内的高新技术企业称号
                    case 12:
                        form.htzte_flag = ed
                        break
                    case "30"://上年度有无研发投入
                    case 30:
                        form.research_input_flag = ed
                        break
                    case "31"://有无授权发明专利
                    case 31:
                        form.invention_patent_flag = ed
                        break
                    case "32"://有无国际科技合作
                    case 32:
                        form.international_cooperation_flag = ed
                        break
                    case "34"://上年度有无固定资产投入
                    case 34:
                        form.investment_fixed_assets_flag = ed
                        break
                    case "38"://企业股东或成员是否有国内外高校或科研院在编、全职人员
                    case 38:
                        form.shareholders_flag = ed
                        break
                    case "39"://企业有无从外地引进博士学历人才
                    case 39:
                        form.nonlocal_dr_flag = ed
                        break
                    case "41"://上年度有贷款
                    case 41:
                        form.last_year_loan_flag = ed
                        break
                    case "43"://上年度有融资
                    case 43:
                        form.last_year_finance_flag = ed
                        break
                    case "42"://未来有贷款计划
                    case 42:
                        form.future_loan_flag = ed
                        break
                    case "48"://未来有融资计划
                    case 48:
                        form.future_finance_flag = ed
                        break
                    case "13":
                    case 13:
                    case "16":
                    case 16:
                    case "19":
                    case 19:
                    case "22":
                    case 22:
                    case "25":
                    case 25:
                        this.getCheckBoxValue(i, ed, '1')
                        break
                    case "14":
                    case 14:
                    case "17":
                    case 17:
                    case "20":
                    case 20:
                    case "23":
                    case 23:
                    case "26":
                    case 26:
                        this.getCheckBoxValue(i, ed, '2')
                        break
                    case "15":
                    case 15:
                    case "18":
                    case 18:
                    case "21":
                    case 21:
                    case "24":
                    case 24:
                    case "27":
                    case 27:
                        this.getCheckBoxValue(i, ed, '3')
                        break
                    case "36":
                    case 36:
                        form.dr_number_flag = ed
                        break
                    case "37":
                    case 37:
                        form.high_level_talents_flag = ed
                        break
                    default:
                        break
                }
            }
            this.formSearch = Object.assign({}, this.formSearch, form)
        },
        getCheckBoxValue(i, e, v) {
            var name = ''
            switch (i) {
                case 13:
                case '13':
                case 14:
                case '14':
                case 15:
                case '15':
                    name = 'technology_center_flag'
                    break
                case 16:
                case '16':
                case 17:
                case '17':
                case 18:
                case '18':
                    name = 'engineering_center_flag'
                    break
                case 19:
                case '19':
                case 20:
                case '20':
                case 21:
                case '21':
                    name = 'engineering_laboratory_flag'
                    break
                case 22:
                case '22':
                case 23:
                case '23':
                case 24:
                case '24':
                    name = 'key_laboratory_flag'
                    break
                case 25:
                case '25':
                case 26:
                case '26':
                case 27:
                case '27':
                    name = 'industrial_design_center_flag'        
                    break
            }
            if (e == '1') {
                let index = this.formSearch[name].findIndex(item => item == 0)
                index != -1 && this.formSearch[name].splice(index,1)
                this.formSearch[name].push(v)
            }
        },
    },
    beforeRouteEnter(to,from ,next){
        if(from.name == 'SearchResult' || from.name == 'Search'){
            to.meta.isBack = true
            to.query = from.query
        }
        next()
    }
}

function debounce(func, wait = 1000) { //可以放入项目中的公共方法中进行调用
    let timeout;
    return function (event) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            func.call(this, event)
        }, wait)
    }
}
</script>
<style lang="scss" scoped>
.index-container {
    .logo-box {
        width: 100%;
        height: 200px;
        background-color: #0079fe;
    }

    .notice-swipe {
        height: 40px;
        line-height: 40px;
    }

    .match-container-search {
        height: 36px;
        // margin: 0 12px;
        display: flex;
        position: relative;
        display: flex;
        flex-direction: row;

        input {
            flex: 1;
            height: 28px;
            border: 0;
            box-sizing: border-box;
            padding: 0 8px;
            font-size: 12px;
            margin: 4px 0;
        }

        .detail {
            width: 100%;
            position: absolute;
            top: 40px;
            left: 0;
            z-index: 999;
            border: 1px solid #ccc;
            box-sizing: border-box;
        }
    }

    .field-ul {
        margin: 0 20px;
        display: flex;
        flex-wrap: wrap;
    }

    .flex-tag-select-container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        box-sizing: border-box;
        z-index: 10;
        overflow: auto;
    }

    .flex-tag-select-item {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #252525;
        min-height: 40px;
        border: 1px solid #fff;
        // padding: 0 16px;
        box-sizing: border-box;
        background: #fff;
    }

    .flex-tag-select-item.selected {
        border: 1px solid #1b53b9;
        color: #1b53b9;
        background: #ebf3fa;
    }
}

.h1-title {
    text-align: center;
}

.main-title {
    font-weight: 700;
    font-size: 18px;
    padding: 0 18px;
}

.float-action {
    .flex-item {
        flex: 1;
        text-align: center;

        &:last-child {
            flex: 1;
        }
    }
}

.boxs .title {
    padding: 0 15px;
    font-size:14px
}

::v-deep(.van-grid-item__icon-wrapper) {
    margin-bottom: 5px;
}

::v-deep .van-radio,
.van-checkbox {
    height: 30px;
}
</style>